import { render, staticRenderFns } from "./DragShadow.vue?vue&type=template&id=38c017b8&"
import script from "./DragShadow.vue?vue&type=script&lang=js&"
export * from "./DragShadow.vue?vue&type=script&lang=js&"
import style0 from "./DragShadow.vue?vue&type=style&index=0&id=38c017b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports